/**
 * @generated SignedSource<<eb43c4f71302a61725cde9311aacb019>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMoreSurveysBannerQuery_profileUrlRef$data = {
  readonly demographicProfileUrl: string | null;
  readonly endlessProfilerUrl: string | null;
  readonly profileCompletionPercentage: {
    readonly profileCompletionPercentage: number;
  } | null;
  readonly profilerUrl: string | null;
  readonly userData: {
    readonly firstName: string | null;
  } | null;
  readonly " $fragmentType": "useMoreSurveysBannerQuery_profileUrlRef";
};
export type useMoreSurveysBannerQuery_profileUrlRef$key = {
  readonly " $data"?: useMoreSurveysBannerQuery_profileUrlRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMoreSurveysBannerQuery_profileUrlRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./MoreSurveysBannerRefetchQuery.graphql')
    }
  },
  "name": "useMoreSurveysBannerQuery_profileUrlRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endlessProfilerUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "demographicProfileUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilerUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileCompletion",
      "kind": "LinkedField",
      "name": "profileCompletionPercentage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileCompletionPercentage",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserData",
      "kind": "LinkedField",
      "name": "userData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5628b6a60d13cdc2a8f94f392698f092";

export default node;
